//记得在 src\components\lang\zhLoad.js 里面添加对象
const distributor = {
  customerNo: '客户编号',
  customerName: '客户名称',
  activeOffName: '是否有效',
  msg: {}
};
export default distributor



// WEBPACK FOOTER //
// ./src/page/md/distributor/lang/distributor.en.js